import { createFileRoute, redirect } from '@tanstack/react-router';

// The app is login-only. Discovery / subscribe / waitlist / "Not sure?" live
// on the marketing site (yesplease.studio). `/` lands at the sign-in page;
// `redirectIfSignedIn` on that route routes an authenticated user to their
// role-home (/portal or /eric).
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/auth/sign-in' });
  },
});
